import axios from "axios";
import jwt_decode from "jwt-decode";
import { toast } from 'react-toastify';
import { BASE_URL } from "../../utils/baseURL";
import setAuthToken from "../../utils/setAuthToken";
import { AUTH_ERROR, CURRENT_USER, SIGN_UP } from "./types";

const customId  = 'bridge'

export const _SIGN_UP = (email, password, country, username, resetForm, setLoadButton) =>  async (dispatch) => {

  const config = {
    headers: {
        's-signature': process.env.REACT_APP_API_SECRET
    }
  };

  try {
    const res = await axios.post(`${BASE_URL}/auth/business/register`, {email, password, country, username}, config)

    dispatch({
      type: SIGN_UP,
      payload: res.data.data  
    })

    resetForm()
    setLoadButton(false)

    toast.success('Account successfully created', { 
      position: toast.POSITION.TOP_CENTER,
      toastId: customId,
    })

  } catch (err) {
    const error = err.response.data.message
    dispatch({
        type: AUTH_ERROR,
        payload: error
    })

    toast.error(error, { 
        position: toast.POSITION.TOP_CENTER,
        toastId: customId,
    })
  }
}


export const _SIGN_IN = (UserCredentials, setLoadButton) => async (dispatch) => {
  const config = {
      headers: {
          's-signature': process.env.REACT_APP_API_SECRET
      }
  };

  try {
      const res = await axios.post(`${BASE_URL}/auth/sign-in`, UserCredentials, config)


      const { token } = res.data.data

      if(token){

          const tokenBearer =  'Bearer '+ token
  
          localStorage.setItem('jwtToken', tokenBearer)
  
          setAuthToken(tokenBearer)
  
          const decoded = jwt_decode(token)
  
          dispatch(setCurrentUser(decoded))
      }

  } catch (err) {
     
      const error = err.response.data.message;

      if (error) {
        toast.error(error, { 
          position: toast.POSITION.TOP_CENTER,
          toastId: customId,
        })

      }

      dispatch({
          type: AUTH_ERROR,
          payload: error
      })

      setLoadButton(false)
  }
}


export const setCurrentUser = (decoded) => {
  return{
      type: CURRENT_USER,
      payload: decoded
  }
}

export const _LOGOUT = () => async (dispatch) => {
  localStorage.removeItem("jwtToken");

  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to empty object {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
}